import React, { useEffect, useRef, useState } from 'react';
import HashLoader from 'react-spinners/HashLoader';
import Footer from '../components/Basic/footer/Footer';
import Nav from '../components/Basic/nav/Nav';
import About from '../components/Home/About/About';
import Contact from '../components/Home/Contact/Contact';
import Experience from '../components/Home/experience/Experience';
import Header from '../components/Home/header/Header';
import Projects from '../components/Home/projects/projects';
const Home = () => {
  const [loading, setLoading] = useState(true);
  const [activeNav, setActiveNav] = useState('#header');

  const sectionsRef = useRef({
    '#header': null,
    '#about': null,
    '#experience': null,
    '#contact': null,
  });

  useEffect(() => {
    setLoading(false);

    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      const sections = Object.keys(sectionsRef.current);
      sections.forEach((section) => {
        const sectionElement = sectionsRef.current[section];
        if (sectionElement) {
          const sectionOffset = sectionElement.offsetTop;
          const sectionHeight = sectionElement.offsetHeight;
          if (scrollPosition >= sectionOffset && scrollPosition < sectionOffset + sectionHeight) {
            setActiveNav(section);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading">
          <HashLoader color={'#4db5ff'} size={50} className="loader" />
        </div>
      ) : (
        <div>
          <section id="header" ref={(el) => (sectionsRef.current['#header'] = el)} style={{ minHeight: '70vh' }}>
            <Header />
          </section>
          <Nav activeNav={activeNav} setActiveNav={setActiveNav} />
          <section id="about" ref={(el) => (sectionsRef.current['#about'] = el)} style={{ minHeight: '70vh' }}>
            <About />
          </section>
          <section id="experience" ref={(el) => (sectionsRef.current['#experience'] = el)} style={{ minHeight: '70vh' }}>
            <Experience />
          </section>
          <section id="projects">
            <Projects />
          </section>
          <section id="contact" ref={(el) => (sectionsRef.current['#contact'] = el)} style={{ minHeight: '70vh' }}>
            <Contact />
          </section>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Home;
